import Vue from 'vue'
import VueRouter from 'vue-router'

import store from './store'

import WelcomePage from './components/navigate/inicio.vue'
import Nosotros from './components/navigate/nosotros.vue'
import Capacitaciones from './components/navigate/capacitaciones.vue'
import Asesorias from './components/navigate/asesorias.vue'
import Contactenos from './components/navigate/contactenos.vue'


import DashboardPage from './components/dashboard/dashboard.vue'
import SignupPage from './components/auth/signup.vue'
import SigninPage from './components/auth/signin.vue'

//contract wizards
import Arriendo from './components/contractWizards/arriendo.vue'
import Pretension from './components/contractWizards/pretension.vue'
import PretensionAvanzado from './components/contractWizards/pretensionAvanzado.vue'
import ContractViewer from './components/contractView/contractViewer.vue'


Vue.use(VueRouter)

const routes = [
  { path: '/', component: DashboardPage,
    beforeEnter (to, from, next) {
      console.log('beforeEnter')
        if (store.state.user) {
          next()
        } else {
          next('/signin')
        }
      
    }
   },
  { path: '/nosotros', component: Nosotros },
  { path: '/capacitaciones', component: Capacitaciones },
  { path: '/asesorias', component: Asesorias },
  { path: '/contactenos', component: Contactenos },


  { path: '/signup', component: SignupPage },
  { 
    path: '/signin', 
    component: SigninPage,
    beforeEnter (to, from, next) {
      if (store.state.user) {
        next('/dashboard')
      } else {
        next()
      }
    
  }
 },
  {
    path: '/dashboard',
    component: DashboardPage,
    beforeEnter (to, from, next) {
      console.log('beforeEnter')
        if (store.state.user) {
          next()
        } else {
          next('/signin')
        }
      
    }
  },
  {
    path: '/arriendo', 
    component: Arriendo,
    beforeEnter (to, from, next) {
        if (store.state.user) {
          next()
        } else {
          next('/signin')
        }
      
    }
  },
  {
    path: '/pretension', 
    component: Pretension,
    beforeEnter (to, from, next) {
        if (store.state.user) {
          next()
        } else {
          next('/signin')
        }
      
    }
  },
  {
    path: '/pretensionAvanzado', 
    component: PretensionAvanzado,
    beforeEnter (to, from, next) {
        if (store.state.user) {
          next()
        } else {
          next('/signin')
        }
      
    }
  },
  {
    path: '/contractViewer', 
    component: ContractViewer,
    beforeEnter (to, from, next) {
        if (store.state.user) {
          next()
        } else {
          next('/signin')
        }
      
    }
  }
]

export default new VueRouter({mode: 'history', routes})


// WEBPACK FOOTER //
// ./src/router.js